<template>
  <div class="back">
    <el-container class="container">
      <el-aside width="300px" style="text-align: left;margin-left: 50px;">
        <el-menu :router="true" :default-active="$route.path" :default-openeds="openeds">
          <el-menu-item index="/index/introduction/model/first/first">
            <span slot="title">使用前必读</span>
          </el-menu-item>
<!--          <el-submenu index="1">-->
<!--            <template slot="title"><i class="el-icon-message"></i>前序准备</template>-->
<!--            <el-menu-item index="1-1">使用前必读</el-menu-item>-->
<!--            <el-menu-item index="1-2">选项2</el-menu-item>-->
<!--            <el-menu-item index="1-3">选项3</el-menu-item>-->
<!--            <el-submenu index="1-4">-->
<!--              <template slot="title">选项4</template>-->
<!--              <el-menu-item index="1-4-1">选项4-1</el-menu-item>-->
<!--            </el-submenu>-->
<!--          </el-submenu>-->
          <el-submenu index="2" >
            <template slot="title">BooleanDA文档小助手</template>
            <el-menu-item index="/index/introduction/model/exe/function">功能介绍</el-menu-item>
            <el-menu-item index="/index/introduction/model/exe/question">常见问题</el-menu-item>
<!--            <el-menu-item index="2-1" @click="toClass('exe','function')">功能介绍</el-menu-item>-->
<!--            <el-menu-item index="2-2" @click="toClass('exe','question')">常见问题</el-menu-item>-->
<!--            <el-menu-item index="2-2" :route="{path:'/index/introduction/model',query:{type:'exe',name:'question'}}">常见问题</el-menu-item>-->
          </el-submenu>
<!--          <el-submenu index="3">-->
<!--            <template slot="title">Word小助手</template>-->
<!--            <el-menu-item index="/index/introduction/model/word/function">功能介绍</el-menu-item>-->
<!--            <el-menu-item index="/index/introduction/model/word/question">常见问题</el-menu-item>-->
<!--          </el-submenu>-->
<!--          <el-submenu index="4">-->
<!--            <template slot="title">Excel小助手</template>-->
<!--            <el-menu-item index="/index/introduction/model/excel/function">功能介绍</el-menu-item>-->
<!--            <el-menu-item index="/index/introduction/model/excel/question">常见问题</el-menu-item>-->
<!--          </el-submenu>-->
<!--          <el-submenu index="5">-->
<!--            <template slot="title">PDF小助手</template>-->
<!--            <el-menu-item index="/index/introduction/model/pdf/function">功能介绍</el-menu-item>-->
<!--            <el-menu-item index="/index/introduction/model/pdf/question">常见问题</el-menu-item>-->
<!--          </el-submenu>-->
<!--          <el-submenu index="6">-->
<!--            <template slot="title">注意事项</template>-->
<!--            <el-menu-item-group>-->
<!--              <template slot="title">分组一</template>-->
<!--              <el-menu-item index="3-1">选项1</el-menu-item>-->
<!--              <el-menu-item index="3-2">选项2</el-menu-item>-->
<!--            </el-menu-item-group>-->
<!--            <el-menu-item-group title="分组2">-->
<!--              <el-menu-item index="3-3">选项3</el-menu-item>-->
<!--            </el-menu-item-group>-->
<!--            <el-submenu index="3-4">-->
<!--              <template slot="title">选项4</template>-->
<!--              <el-menu-item index="3-4-1">选项4-1</el-menu-item>-->
<!--            </el-submenu>-->
<!--          </el-submenu>-->
        </el-menu>
        <div style="height: 200px"></div>
      </el-aside>
      <el-main>
        <div class="content">
          <router-view></router-view>
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import * as path from 'path'

export default {
  name: 'App',
  components: {
    // HelloWorld,
    // FixedHeader
  },
  data() {
    return {
      tableData: [],
      activeNum: '1',
      openeds: ['2']
    }
  },
  created() {
    // css不是很好设置，通过组件生命周期设置滚动条属性
    document.body.style.overflow = 'hidden' // 隐藏body元素的滚动条
  },
  mounted() {
    // console.log(this.$route.path)
  },
  beforeDestroy() {
    document.body.style.overflow = 'auto' // 恢复body元素的默认overflow属性
  },
  methods: {
    path() {
      return path
    },
    toClass(typeString, nameString) {
      this.$router.push({
        path: '/index/introduction/model',
        query: { type: typeString, name: nameString }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.back{
  margin-top: 85px;
  width: calc(100vw);
}
.container{
  height: calc(100vh);
}
::v-deep.el-menu{
  .el-menu-item{
    height: 45px;
    margin-left: 8px;
    text-align: left;
    font-size:16px !important;
  }
  .el-menu-item:hover{
    color: #409EFF !important;
  }
  .el-submenu{
    margin-left: 8px;
  }
  .el-submenu:hover{
  }
  .el-submenu__title{
    font-size:16px !important;
  }
  .el-submenu__title:hover{
    color: #409EFF !important;
  }
  .el-submenu__title:active{
  }
}
::v-deep.el-aside::-webkit-scrollbar {
  width: 5px; /*滚动条宽度*/
  height: 10px; /*滚动条高度*/
}
::v-deep.el-aside::-webkit-scrollbar-track {
  box-shadow: 0px 1px 3px #FFFFFF inset; /*滚动条的背景区域的内阴影*/
  border-radius: 10px; /*滚动条的背景区域的圆角*/
  background-color: #FFFFFF; /*滚动条的背景颜色*/
}
::v-deep.el-aside::-webkit-scrollbar-thumb {
  box-shadow: 0px 1px 3px #e3e4e5 inset; /*滚动条的内阴影*/
  border-radius: 10px; /*滚动条的圆角*/
  background-color: #e3e4e5; /*滚动条的背景颜色*/
}
// main的滚动条
::v-deep.el-main::-webkit-scrollbar {
  width: 5px; /*滚动条宽度*/
  height: 10px; /*滚动条高度*/
}
::v-deep.el-main::-webkit-scrollbar-track {
  box-shadow: 0px 1px 3px #FFFFFF inset; /*滚动条的背景区域的内阴影*/
  border-radius: 10px; /*滚动条的背景区域的圆角*/
  background-color: #FFFFFF; /*滚动条的背景颜色*/
}
::v-deep.el-main::-webkit-scrollbar-thumb {
  box-shadow: 0px 1px 3px #409EFF inset; /*滚动条的内阴影*/
  border-radius: 10px; /*滚动条的圆角*/
  background-color: #409EFF; /*滚动条的背景颜色*/
}
</style>

